import HomeFloorBox from './home-floor-box';
import DigitCard from './digit-card';
import React from 'react';
import MoreBtn from './home-floor-more-btn';
import {DigitListItem} from '@/pages/home/home.type';
import {getDigitList} from '@/pages/home/home.service';

interface HomeFloorCarProps {
  name: string;
  id: string;
  serverTime?: number;
  shown?: boolean;
  categoryPic?: string;
}

const HomeFloorDigit = ({
  name,
  id,
  categoryPic,
  serverTime = 0,
  shown = true,
}: HomeFloorCarProps) => {
  const [gameList, setGameList] = React.useState<DigitListItem[]>([]);

  const timer = React.useRef<NodeJS.Timeout>();
  const currentRef = React.useRef(0);
  const [currentTime, setCurrentTime] = React.useState(0);
  const [more, setMore] = React.useState(false);

  React.useEffect(() => {
    getDigitList().then(res => setGameList(res || []));
  }, []);

  React.useEffect(() => {
    if (serverTime && serverTime > 0) {
      startRemaining(serverTime);
    }
  }, [serverTime]);

  const startRemaining = (time = 0) => {
    timer.current && clearInterval(timer.current);
    currentRef.current = time;
    setCurrentTime(currentRef.current);
    timer.current = setInterval(() => {
      currentRef.current = currentRef.current + 1000;
      setCurrentTime(currentRef.current);
    }, 1000);
  };

  React.useEffect(() => {
    return () => {
      timer.current && clearInterval(timer.current);
    };
  }, []);

  return (
    <HomeFloorBox
      shown={shown}
      gameType="3d"
      id={id}
      name={name}
      categoryPic={categoryPic}
      rightNode={<MoreBtn expend={more} onClick={() => setMore(!more)} />}>
      <>
        {(more ? gameList : gameList.slice(0, 6)).map((item, _i) => (
          <DigitCard
            v={item}
            key={_i}
            index={_i}
            serverTime={serverTime}
            currentTime={currentTime}
          />
        ))}
      </>
    </HomeFloorBox>
  );
};

export default HomeFloorDigit;
